export enum E_USER_PERMISSIONS {
    CONTENT_CREATOR = 'content-creator',
    HOST = 'host',
    ADMIN = 'admin',
    CRTITIC = 'critic',
    JURY = 'jury',
    TESTER = 'tester',
    USER = 'user',
    CASTING_DIRECTOR = 'casting-director',
    SCREEN_WRITER = 'screen_writer',
    EDITOR = 'editor',
    INFLUENCER = 'influencer',
    SUPER_ADMIN = 'super-admin',
    TUTOR = 'tutor',
}

export enum E_USER_TYPES {
    ACTOR = 'actor',
    CASTING_DIRECTOR = 'casting_director',
    CONTENT_CREATOR = 'content_creator',
    SKIT_MAKER = 'skit maker',
    SCREEN_WRITER = 'screen_writer',
    ARTIST = 'artist',
    ACTRESS = 'actress',
    CHILD_ACTOR = 'child actor',
    FILMMAKER = 'filmmaker',
    EDITOR = 'editor',
    INFLUENCER = 'influencer',
    SUPER_ADMIN = 'super-admin',
}

/** This is derived from the role for the user */
export type UserPermissionLevels =
    | 'actor'
    | 'casting-director'
    | 'content-creator'
    | 'screen_writer'
    | 'host'
    | 'admin'
    | 'critic'
    | 'jury'
    | 'tester'
    | 'user'
    | 'editor'
    | 'influencer'
    | 'super-admin'
    | 'tutor';

export const pagePermissions: Record<string, Partial<Record<E_USER_PERMISSIONS, boolean>>> = {
    buzzbridge: {
        [E_USER_PERMISSIONS.HOST]: true,
        [E_USER_PERMISSIONS.ADMIN]: true,
        [E_USER_PERMISSIONS.SUPER_ADMIN]: true,
        [E_USER_PERMISSIONS.INFLUENCER]: true,
    },
    talents: {
        [E_USER_PERMISSIONS.ADMIN]: true,
        [E_USER_PERMISSIONS.SUPER_ADMIN]: true,
        [E_USER_PERMISSIONS.HOST]: true,
        [E_USER_PERMISSIONS.CASTING_DIRECTOR]: true,
    },
    'jury duty': {
        [E_USER_PERMISSIONS.CONTENT_CREATOR]: false,
        [E_USER_PERMISSIONS.EDITOR]: false,
        [E_USER_PERMISSIONS.SUPER_ADMIN]: true,
        [E_USER_PERMISSIONS.ADMIN]: true,
        [E_USER_PERMISSIONS.JURY]: true,
    },
    'sandbox studio': {
        [E_USER_PERMISSIONS.TUTOR]: true,
        [E_USER_PERMISSIONS.ADMIN]: true,
        [E_USER_PERMISSIONS.SUPER_ADMIN]: true,
    },
};
